// extracted by mini-css-extract-plugin
export default {"codeBoxContainer":"APCodeBox_codeBoxContainer__Bm+uG","codeBox":"APCodeBox_codeBox__JH1SJ","icon":"APCodeBox_icon__u4nGc"};